/**
 * theme.js - Main entry point
 * 
 * All modules are self-initializing via IIFE pattern.
 * Modules are loaded via <script> tags in theme.liquid in order:
 *   1. header.js - Header interactions
 *   2. collection.js - Collection page (future)
 *   3. product.js - Product page (future)
 * 
 * This file ensures proper loading order and provides any global utilities.
 */

// Theme namespace for global access
window.theme = window.theme || {};

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('Theme initialized');
});
